export const LOAD_NGUM_STATUS = "ngum/load";
export const LOAD_NGUM_STATUS_SUCCESS = "ngum/load/success";
export const LOAD_NGUM_STATUS_FAILURE = "ngum/load/failure";

export const TOGGLE_NGUM = "ngum/toggle";
export const TOGGLE_NGUM_SUCCESS = "ngum/toggle/success";
export const TOGGLE_NGUM_FAILURE = "ngum/toggle/failure";

export const loadNGUMStatus = () => {
  return {
    types: [
      LOAD_NGUM_STATUS,
      LOAD_NGUM_STATUS_SUCCESS,
      LOAD_NGUM_STATUS_FAILURE,
    ],
    promise: (client) => client.get(`/companies/ngumSwitch`),
  };
};

export const toggleNGUM = (onSuccess) => {
  return (dispatch, getState) => {
    const model = getState().ngum.data || {};
    const data = {
      ...model,
      status_id: model.status_id === 0 ? 1 : 0,
    };
    return dispatch({
      types: [TOGGLE_NGUM, TOGGLE_NGUM_SUCCESS, TOGGLE_NGUM_FAILURE],
      promise: (client) => client.post(`/companies/saveNgumSwitch`, { data }),
      onSuccess: () => {
        dispatch(loadNGUMStatus());
        onSuccess && onSuccess();
      },
      isActive: model.status_id === 1,
    });
  };
};
